import * as z from "zod/v4";
import { aeoDateRangeInput } from "./types";

const CompetitorDataSchema = z.object({
  name: z.string(),
  mentions: z.number(),
  website: z.string(),
  isYou: z.boolean(),
  rank: z.number(),
});
export type CompetitorData = z.infer<typeof CompetitorDataSchema>;

export const getCompetitorComparison = {
  name: "getCompetitorComparison" as const,
  input: aeoDateRangeInput,
  output: z.object({
    brand: CompetitorDataSchema,
    topMentionedBrands: z.array(CompetitorDataSchema),
  }),
};
